import { navigationConstants } from "actions/types";
import type { NavState } from "types/state";

interface NavAction {
  type: string;
  data?: unknown;
}

const initialState: NavState = {
  tab: {
    tabObject: "",
    tabValue: "",
    topicId: "",
  },
  company: {
    companyId: "",
    companyName: "",
  },
};

export function nav(
  state: NavState = initialState,
  action: NavAction
): NavState {
  switch (action.type) {
    case navigationConstants.NAVIGATION_SET_TAB_FAILURE:
      return {
        ...state,
        tab: {
          tabObject: "",
          tabValue: "",
          topicId: "",
        },
      };
    case navigationConstants.NAVIGATION_SET_TAB_SUCCESS: {
      const data = action.data as NavState["tab"];
      return {
        ...state,
        tab: {
          tabObject: data.tabObject,
          tabValue: data.tabValue,
          topicId: data.topicId,
        },
      };
    }
    case navigationConstants.NAVIGATION_SET_COMPANY_FAILURE:
      return {
        ...state,
        company: {
          companyId: "",
          companyName: "",
        },
      };
    case navigationConstants.NAVIGATION_SET_COMPANY_SUCCESS: {
      const data = action.data as NavState["company"];
      return {
        ...state,
        company: {
          companyId: data.companyId,
          companyName: data.companyName,
        },
      };
    }
    default:
      return state;
  }
}
